export default __webpack_public_path__ + "static/printer_w.c5f19b981b26e23e55f7dd0ed00a7658.png";